import { useAuth } from "@/context/AuthContext";
import { SupportNavigator, ContactGuide, PlannedCards, Articles } from "@/components/employee-center/Sections";
import { EC_DISCLAIMER } from "@/lib/employeeCenter";

// Phase 1 foundation: static, frontend-only. No data collection, storage, submissions or AI.
export default function EmployeeCenter() {
  const { user } = useAuth();
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-testid="employee-center">
      <header data-testid="employee-center-header">
        <div className="text-xs uppercase tracking-[0.2em] text-[#C7761A] font-bold">Employee Center</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#0A2A5E] mt-1">Welcome{user?.name ? `, ${user.name.split(" ")[0]}` : ""}</h1>
        <p className="text-sm text-slate-600 mt-2 max-w-2xl">Find the right LUMIS HR resource for what you need today — forms, policies, learning and source-guided answers — plus general guidance on who to contact.</p>
        <p data-testid="employee-privacy-statement" className="text-xs text-slate-500 mt-2 max-w-2xl">Private employee preparation stays separate from information the employee intentionally submits.</p>
      </header>
      <div className="grid lg:grid-cols-12 gap-6">
        <div className="lg:col-span-7 space-y-6"><SupportNavigator /><Articles /></div>
        <div className="lg:col-span-5 space-y-6"><ContactGuide /><PlannedCards /></div>
      </div>
      <footer className="text-[11px] text-slate-500 border-t border-slate-200 pt-3" data-testid="employee-center-disclaimer">{EC_DISCLAIMER}</footer>
    </div>
  );
}
